import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Layout from "@/components/feature/Layout";
import Home from "../pages/home/page";
import TvSeriesCategory from "../pages/category/tv-series/page";
import NewsCategory from "../pages/category/news/page";
import ActorsCategory from "../pages/category/actors/page";
import TvDetail from "../pages/detail/tv/page";
import NewsDetail from "../pages/detail/news/page";
import SearchPage from "../pages/search/page";
import About from "../pages/about/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Layout />,
    children: [
      { index: true, element: <Home /> },
      { path: "category/tv-series", element: <TvSeriesCategory /> },
      { path: "category/news", element: <NewsCategory /> },
      { path: "category/actors", element: <ActorsCategory /> },
      { path: "detail/tv/:id", element: <TvDetail /> },
      { path: "detail/news/:id", element: <NewsDetail /> },
      { path: "search", element: <SearchPage /> },
      { path: "about", element: <About /> },
      { path: "*", element: <NotFound /> },
    ],
  },
];

export default routes;